import React from 'react'

import { Form, CheckboxProps } from 'semantic-ui-react'
import { Typography, Box, Card, CardContent } from '@mui/material'

import CustomLabel from '../../../components/common/custom-label/CustomLabel'

import { IProject } from '../../../api/Data'

const SettingsCard = (props: IProps) => {
  // Props
  const { project, handleChange } = props

  const { name, shouldEmailEverySubmission } = project

  const handleCheckboxChange = (e: React.MouseEvent<HTMLInputElement, MouseEvent>, data: CheckboxProps) => {
    const { name, checked } = data
    
    handleChange(e, {
      name: String(name),
      checked:  Boolean(checked),
    })
  }
  
  return (
    <Card sx={{ width: '100%', boxSizing: 'border-box' }}>
      <CardContent>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="h5" fontWeight="bold">
            Notification Settings
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            Submission Notification Frequency
          </Typography>
          <Form>
            <Form.Field>
              <CustomLabel>
                <CustomLabel.Text text="Every Submission" />
                <CustomLabel.Popup popupContent={`Notify when ${name} receives a submission`} />
                <CustomLabel.Checkbox
                  name="shouldEmailEverySubmission"
                  checked={shouldEmailEverySubmission}
                  onClick={handleCheckboxChange}
                />
              </CustomLabel>
            </Form.Field>
          </Form>
        </Box>
      </CardContent>
    </Card>
  )
}

interface IProps {
  project: IProject
  handleChange: (
    arg: React.SyntheticEvent,
    { name, checked }: { name: string; checked: boolean }
  ) => void
}

export default SettingsCard
